import { useState, useContext, useEffect } from "react";
import {
	Container,
	Group,
	Image,
	Button,
	ColorInput,
	Checkbox,
	Modal,
} from "@mantine/core";
import ExperienceContext from "./ExperienceContext";
import videoPlaneIcon from "../../static/svg/video-plane.svg";
import { CDN_URL } from "../../constant";

function VideoPlaneControls({ activePanoId, selectedObject, closeControls}) {
	const [isViewOpen, setIsViewOpen] = useState(false);
	const [isChroma, setIsChroma] = useState(false);
	const [chromaColor, setChromaColor] = useState("#00FF00");
	const { deleteVideoPlane, setVideoPlaneIsChroma, setVideoPlaneChromaKey } =
		useContext(ExperienceContext);

	useEffect(() => {
		setIsChroma(selectedObject.isChroma);
		setChromaColor(selectedObject.chromaKey);
	}, [selectedObject]);

	return (
		<>
			<Group
				style={{
					height: "96px",
					width: "340px",
					backgroundColor: "#040f1fcc",
					padding: "10px 20px 10px 20px",
					borderRadius: "5px",
				}}
			>
				<Container
					px={0}
					mx={0}
					style={{
						backgroundColor: "#00000099",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						width: "50px",
						height: "50px",
						borderRadius: "50px",
					}}
				>
					<Image src={videoPlaneIcon} alt="Video" width="25px" />
				</Container>
				<Container px={0} mx={0} style={{ width: "230px" }}>
					<Group direction="column" spacing={10}>
						<Group
							direction="row"
							style={{
								justifyContent: "start",
								alignItems: "center",
								width: "100%",
								height: "30px",
							}}
						>
							<Button
								variant="outline"
								size="xs"
								radius={"sm"}
								py={5}
								style={{
									fontWeight: "normal",
									fontSize: "14px",
									color: "#ffffff",
									borderColor: "#4dabf7",
								}}
								onClick={() => {
									setIsViewOpen(true);
								}}
							>
								View Video
							</Button>
							<Button
								variant="outline"
								size="xs"
								radius={"sm"}
								py={5}
								style={{
									fontWeight: "normal",
									fontSize: "14px",
									color: "#ffffff",
									backgroundColor: "#e03131",
									borderColor: "#e03131",
								}}
								onClick={() => {
									deleteVideoPlane(
										activePanoId,
										selectedObject.id
									);
									closeControls();
								}}
							>
								Delete
							</Button>
						</Group>
						<Group
							direction="row"
							position="right"
							style={{ height: "30px" }}
						>
							<Checkbox
								label="Is Chroma"
								size="sm"
								checked={isChroma}
								onChange={(event) => {
									setIsChroma(event.target.checked);
									setVideoPlaneIsChroma(
										activePanoId,
										selectedObject.id,
										event.target.checked
									);
								}}
							/>
							{isChroma && (
								<ColorInput
									size="xs"
									format="rgb"
									value={chromaColor}
									style={{
										width: "100px",
									}}
									styles={{
										input: { backgroundColor: "#040F1F55" },
									}}
									onChange={(color) => {
										setChromaColor(color);
										setVideoPlaneChromaKey(
											activePanoId,
											selectedObject.id,
											color
										);
									}}
								/>
							)}
						</Group>
					</Group>
				</Container>
			</Group>
			<Modal
				centered
				size="lg"
				opened={isViewOpen}
				onClose={() => setIsViewOpen(false)}
				title={"Uplaoded Video"}
				styles={{
					modal: { backgroundColor: "#040F1F" },
					title: { color: "#ffffff", fontWeight: "700" },
					body: { maxHeight: "80%" },
				}}
			>
				<Group position="center">
					<video controls width="100%">
						<source
							src={CDN_URL + selectedObject.url}
							type="video/mp4"
						/>
						Your browser does not support the video tag.
					</video>
				</Group>
			</Modal>
		</>
	);
}

export default VideoPlaneControls;
